export default "__VITE_ASSET__DrDMUYUe__"